const containsConsecutives = (s, r) => {
    const controlKeys = Array.from(Array(r).keys());
    for (const i in s) {
        if (
            controlKeys.map(k => +s[+i + k + 1] == +s[i] + (k + 1)).filter(x => !!x).length == r ||
            controlKeys
                .map(k => String.fromCharCode(s.charCodeAt(i) + k + 1) == s[+i + (k + 1)])
                .filter(x => !!x).length == r
        ) {
            return true;
        }
    }
    return false;
};

export default containsConsecutives;
